import {chain} from "../../utils/fs";

import {formatNumberBig} from "./format-number-big";

export const formatMoney = (amount, {freeLabel="Free", useFreeLabel=true, alwaysShowDollarSymbol=false, signDisplay}={}) => {
    if (typeof amount === "string") {
        amount = +amount;
    }
    if (Math.abs(amount) < 0.01) {
        return useFreeLabel ? freeLabel : Number(0).toLocaleString(undefined, {style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2, signDisplay});
    }
    if (Math.abs(amount) < 1 && !alwaysShowDollarSymbol) {
        return chain(
            (() => {
                if (String(amount).length == 6) {
                    return ((Math.round(amount*10000))/100) + "¢";
                } else {
                    return Math.round(amount*100) + "¢"
                }
            })(),
            (_) => signDisplay !== "exceptZero" || amount <= 0 ? _ : "+" + _,
        );
    } else {
        if (Math.abs(amount) < 1 && String(amount).length == 6) {
            return (Math.round(amount*10000)/10000).toLocaleString(undefined, {style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 4, signDisplay});
        }
        else {
            return (Math.round(amount*100)/100).toLocaleString(undefined, {style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2, signDisplay});
        }
    }
};
export const formatMoney2 = (amount) => {
    if (Math.abs(amount) < 1 && String(amount).length == 6) {
        return (Math.round(amount*10000)/10000).toLocaleString(undefined, {style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 4});
    }
    else {
        return (Math.round(amount*100)/100).toLocaleString(undefined, {style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2});
    }
};
export const formatMoneyUS = (amount) => {
    return 'US'+formatMoney(amount, {useFreeLabel:false});
};
export const formatMoney1 = (amount) => {
    return formatMoney(amount, {useFreeLabel:false});
};

export const formatMoneyBig = (amount) => {
    return "$" + formatNumberBig(amount);
};

export const formatMoneyBig1 = (amount) => {

    const k = 1000;
    const mil = 1000*1000;

    if (amount >= 10*mil) {
        return "$" + Math.round(amount / mil) + "m";
    } else if (amount >= 10*k) {
        return "$" + Math.round(amount / k) + "k";
    } else {
        return "" + (Math.round(amount*100)/100);
    }
};

export const formatMoneyBackOptions = (amount) => {
    if (amount === 0) {
        return '';
    }
    if (amount < 1) {
        return `Additional ${Math.round(amount*100)}¢ per piece`
    } else {
        return `Additional $${(Math.round(amount*100)/100).toFixed(2)} per piece`
    }
};